import * as React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { BLOCKS } from '@contentful/rich-text-types';
import Youtube from '@components/Youtube';
import PostAd from '@components/blog/PostAd';
import PostImage from '@components/blog/PostImage';
import TipSection from '@components/blog/TipSection';
import Quote from '@components/sections/Quote/indexCompose';
import * as styles from './style.module.scss';
import BoxWithNumbers from '@components/blog/BoxWithNumbers';
import KeywordsSection from '@components/blog/KeywordsSection';
import AccordionItem from '@components/sections/AccordionItem/index';

const {
  postContent,
  postContent__summary,
  postContent__intro,
  postContent__content,
  postContent__img,
} = styles;

const Content = ({ sixtySecondSummary, introduction, introOnly = false, content, references = [] }) => {
  let headingId = -1;

  const renderOptions = {
    renderNode: {
      [BLOCKS.EMBEDDED_ENTRY]: (node) => {
        const nodeId = node.data.target.sys.id;
        let type = '';
        let data = {};
        references.forEach((item) => {
          if (item.contentful_id === nodeId) {
            data = { ...item };
            type = item.type;
            return;
          }
        });
        if (data && type === 'video') {
          return <Youtube videoId={data.videoId} modifier={'blog'} />;
        }
        if (data && type === 'ad') {
          return <PostAd content={data} />;
        }
        if (data && type === 'accordion') {
          return (
            <AccordionItem
              content={{
                heading: data.title,
                accordionData: data.accordionItems,
              }}
            />
          );
        }
        if (data && type === 'image') {
          return <PostImage content={data} />;
        }
        if (data && type === 'tip') {
          return <TipSection content={data} />;
        }
        if (data && type === 'iframe') {
          return (
            <iframe
              id="inlineFrameExample"
              title={data.title || `Embedded content from ${data.url}`}
              width="700"
              height="400"
              src={data.url}
            ></iframe>
          );
        }
        if (data && type === 'boxwithnumbers') {
          return <BoxWithNumbers content={data} />;
        }
        if (data && type === 'keywords-section') {
          return <KeywordsSection content={data} />;
        }
        if (data && type === 'quote') {
          return (
            <Quote
              key={data.index}
              text={data.quoteText.internal.content}
              icon={data.icon?.svg.originalContent}
              author={{
                name: data.authorName,
                position: data.authorPosition,
                avatar: data.authorProfilePicture,
              }}
              type={data.type}
            />
          );
        }
      },
      [BLOCKS.HEADING_2]: (node) => {
        headingId++;
        return <h2 id={headingId}>{node.content[0].value}</h2>;
      },
      [BLOCKS.EMBEDDED_ASSET]: (node) => {
        const nodeId = node.data.target.sys.id;
        let data = {};
        references.forEach((item) => {
          if (item.contentful_id === nodeId) {
            data = { ...item };
            return;
          }
        });
        const img = getImage(data.gatsbyImageData);
        return img ? (
          <GatsbyImage
            className={postContent__img}
            image={img}
            alt={data.description}
          />
        ) : null;
      },
    },
  };

  const renderRichText = () => {
    if (sixtySecondSummary) {
      return documentToReactComponents(sixtySecondSummary, renderOptions);
    }
    if (content) {
      return documentToReactComponents(content, renderOptions);
    }
    return null;
  };

  return (
    <section className={postContent}>
      {sixtySecondSummary && (
        <div className={postContent__summary}>
          {documentToReactComponents(sixtySecondSummary, renderOptions)}
        </div>
      )}
      <div
        className={postContent__intro}
        dangerouslySetInnerHTML={{ __html: introduction }}
      />
      {!introOnly && content && (
        <div className={postContent__content}>
          {documentToReactComponents(content, renderOptions)}
        </div>
      )}
    </section>
  );

};

export default Content
